<a
	*ngIf="!isR103"
	class="c-menu__link"
	[ngClass]="{ inactive: isDisabled, active: !isDisabled, enabledLink: isActive }"
	(click)="allow ? navigate() : (allow = false)"
>
	<span class="c-menu__text" [ngClass]="{ inactive: isDisabled, active: !isDisabled }" style="font-size: 1.3em">
		<div [ngClass]="{ 'menu_active_item primary-color': isActive }">
			<div>
				{{ sectiontitle }}
			</div>
		</div>
	</span>
</a>
<div *ngIf="isR103">
	<div
		class="c-menu__link {{ sectiontitle }}"
		[ngClass]="{ inactive: isDisabled, active: !isDisabled, enabledLink: isActive }"
		(click)="allow ? navigate() : (allow = false)"
	>
		<div class="dooh-tooltip-helper" style="display: none">
			<span class="c-menu__text" [ngClass]="{ inactive: isDisabled, active: !isDisabled }" style="font-size: 1.3em">
				<div [ngClass]="{ 'menu_active_item primary-color': isActive }">
					<div>
						{{ sectiontitle }}
					</div>
				</div>
			</span>
			<div class="tooltip-container" style="display: none">
				<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
					<path
						d="M7.66667 9.66667H7V7H6.33333M7 4.33333H7.00667M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
						stroke="white"
						stroke-width="1.5"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				<span class="tooltip-text"
					>Impression totals may vary slightly between different widgets due to the nature of DOOH advertising.</span
				>
			</div>
		</div>
		<span class="c-menu__text" [ngClass]="{ inactive: isDisabled, active: !isDisabled }" style="font-size: 1.3em">
			<div [ngClass]="{ 'menu_active_item primary-color': isActive }">
				<div>
					{{ sectiontitle }}
				</div>
			</div>
		</span>
		<app-printable-report-item-r1 *ngIf="isActive && !isDisabled"></app-printable-report-item-r1>
		<app-product-csv-downnload-r6 [key]="sectiontitle" *ngIf="isActive && !isDisabled"></app-product-csv-downnload-r6>
	</div>
</div>
